// extracted by mini-css-extract-plugin
export default {"infinity":"hJmV5","settings":"sgbJC","settings--max":"IXjfI"};